// extracted by mini-css-extract-plugin
export default {"otpContainer":"InputOTP_otpContainer__sH+dk","otpInput":"InputOTP_otpInput__mEJpy"};